import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from "@/util/BASEAPI";

@Component({})
export default class OCPrizeGroupTtl extends Mixins(BASEComponentVue) {
    @Prop({
        type: Object,
        default: () => { return { "id": "0" } }
    })
    prizeGroup!: BASEAPI.ProductPrizeGroup;
}
